import { context, type Span, trace } from '@opentelemetry/api';
import { apiGet } from '@/api/apiClient';
import type { ArticleSummary } from '@/api/articles/types';
import { instrumentAsync } from '@/otel';

export async function listArticles(limit?: number): Promise<ArticleSummary[]> {
  return instrumentAsync('api.articles.listArticles', async (span: Span) => {
    const res = await apiGet<ArticleSummary[]>(
      `/articles/`,
      trace.setSpan(context.active(), span),
      {
        params: {
          limit,
        },
      },
    );

    return res.data;
  });
}
